module.exports = __webpack_public_path__ + "static/img/9.174ade7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/9.png
// module id = dy0n
// module chunks = 0